import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CodatCompanyRefreshRequest } from './codat-company-refresh-request.entity';

export class UpdateCodatCompanyRefreshRequestDto extends Partial(Omit(CodatCompanyRefreshRequest, BaseEntityFieldsArray)) {}
